import { html } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { styleMap } from 'lit/directives/style-map';
import componentStyles from './image-nav.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

export default class ImageNav extends OutlineElement {
  static styles = [super.styles, componentStyles];
  static get properties() {
    return {
      links: { type: Array },
      listDirection: { type: String },
      navClass: { type: String },
      title: { type: String },
      hideText: { type: Boolean },
    };
  }

  constructor() {
    super();
    this.listDirection = '';
    this.navClass = '';
    this.hideText = false;
  }

  render() {
    return html`
      <nav role="navigation" title="${this.title}">
        <ul
          class="${classMap({
            'image-navigation': true,
            [`image-navigation--${this.listDirection}`]: !!this.listDirection,
            [`image-navigation--${this.navClass}`]: !!this.navClass,
          })}"
        >
          ${this.links.map(link => {
            return html` <li
              class="image-navigation--item"
            >
              <hf-button
                ?disabled=${link.disabled}
                type="${link.colorsInverted ? 'image-nav-secondary' : 'image-nav'}"
                href="${link.url}"
                target="${link.target}"
                class="image-navigation--button"
                ignoreExternalUrl
              >
                <span class="image-navigation__text"><p>${link.text}</p></span>
                <image class="image-navigation__image" src="${link.image.src}" alt="${link.image.src}" />
              </hf-button>
            </li>`;
          })}
        </ul>
      </nav>
    `;
  }
}

customElements.define('hf-image-nav', ImageNav);
